import { Pagination } from '../../../models/Pagination';
import { http } from '../axios';
import { shopPrefix } from '../../config';
import { ProductsResponseOut } from '../../store/api';

type ParameterTypes = {
    bundleId: string;
    pagination: Pagination;
    filterMap: string;
};

const url = `${shopPrefix}/v1/bundles/:bundleId/products`;

export const fetchBundleDetailProducts = ({ bundleId, filterMap, pagination }: ParameterTypes) => {
    return http
        .post<ProductsResponseOut>(url, filterMap, {
            pathParams: {
                bundleId
            },
            params: {
                ...pagination
            }
        })
        .then(res => res.data);
};
